import { Product } from "@/types/types.ts";
import { DMS_IDS } from "@/constants/constants";

const chargeableReturnsSellingProductTypes = [
  "Adaptors",
  "Barbecues",
  "Beds",
  "Bedside Chests & Tables",
  "Benches",
  "Bikes",
  "Bookcases",
  "Cabinets",
  "Chairs",
  "Cooker Hoods",
  "Cookers",
  "Cotbeds",
  "Cots",
  "Cribs",
  "Cross Trainers",
  "Deckchairs",
  "Desks",
  "Dishwashers",
  "Drawer Units",
  "Dressers",
  "Dressing Tables",
  "Drinks Trolleys",
  "Exercise Bikes",
  "Filing Cabinets",
  "Fitness Weights",
  "Footstools",
  "Freezers",
  "Fridge Freezers",
  "Fridges",
  "Garden Armchairs",
  "Garden Benches",
  "Garden Dining Chairs",
  "Garden Dining Sets",
  "Garden Lounge Sets",
  "Garden Sofa Sets",
  "Garden Sofas",
  "Garden Tables",
  "Gazebos",
  "Greenhouses",
  "Headboards",
  "Hobs",
  "Hot Tubs & Saunas",
  "Kitchen Trolleys",
  "Mattresses",
  "Microwaves",
  "Mirrors",
  "Multi Gyms",
  "Nursing Chairs",
  "Ottomans",
  "Outdoor Storage",
  "Outdoor Toys",
  "Oven Warming Drawers",
  "Ovens",
  "Parasols",
  "Patio Heaters",
  "Pots & Planters",
  "Potting Tables",
  "Rowing Machines",
  "Sheds",
  "Sideboard",
  "Sofas",
  "Stools",
  "Storage Cabinet",
  "Storage Containers",
  "Summerhouses",
  "Sunlounger",
  "Table Tennis Tables",
  "Tables",
  "Training Aids",
  "Treadmills",
  "TV Stands",
  "Wardrobe Drawers",
  "Wardrobe Lights",
  "Wardrobe Shelves",
  "Wardrobes",
  "Washer Dryers",
  "Wine Cabinets",
];

export const isEligibleForFreeReturns = (product: Product) => {
  const availableOptions = product.fulfilmentOptions?.available ?? [];
  const isSupplierDirect = availableOptions.some(
    (option) => option.aliases.dmsId === DMS_IDS.SupplierDelivery,
  );

  return !(
    chargeableReturnsSellingProductTypes.includes(
      product.sellingProductType || "",
    ) && isSupplierDirect
  );
};
